export type VerificationTimerRecord<T = unknown> = {
  data: T
  dieAfter: number
}

interface IVerificationTimer<T extends Record<string, unknown>> {
  status: VerificationTimerRecord<T>
  isExpired: boolean
  destroy: () => boolean
  init: (deltaTime: number, payload: T) => void
  startTimer: (intervalCb?: () => void, destroyCb?: () => void) => void
}

export class VerificationTimer<T> implements IVerificationTimer<T> {
  dieAfter: number | null = null
  interval: unknown

  constructor() {
    this.dieAfter = this.status?.dieAfter || null
  }

  get status(): VerificationTimerRecord<T> | null {
    try {
      return JSON.parse(sessionStorage.getItem('verificationSentStatus'))
    } catch (e) {
      return null
    }
  }

  deltaTime() {
    return (this.dieAfter - Date.now()) / 1000
  }

  get isExpired() {
    return Date.now() > this.status?.dieAfter
  }

  destroy() {
    try {
      sessionStorage.removeItem('verificationSentStatus')
      clearInterval(this.interval)
      return true
    } catch (e) {
      throw new Error('Error destroy validation code status')
    }
  }

  init(deltaTime: number, payload: T): void {
    try {
      this.dieAfter = Date.now() + deltaTime * 1000
      sessionStorage.setItem(
        'verificationSentStatus',
        JSON.stringify({
          data: payload,
          dieAfter: this.dieAfter,
        })
      )
    } catch (e) {
      throw new Error('Error set validation code status')
    }
  }

  setup(intervalCb?: () => void, destroyCb?: () => void) {
    clearInterval(this.interval)
    intervalCb && intervalCb()
    this.interval = setInterval(() => {
      if (!this.isExpired) {
        intervalCb && intervalCb()
      } else {
        this.destroy()
        destroyCb && destroyCb()
      }
    }, 500)
  }
}
